import { Filter } from '@ami/react/core';

export class ProductOptionFilter extends Filter {
  constructor(filter) {
    super(filter);
    if (filter) {
      this.search = filter.search;
      this.supplierLeadTimeId = filter.supplierLeadTimeId;
      this.exceptProductOptionIds = filter.exceptProductOptionIds;
      this.includeRetired = filter.includeRetired;
      this.alwaysIncludeImages = filter.alwaysIncludeImages;
      this.standaloneItem = filter.standaloneItem;
      this.partNumberLogic = filter.partNumberLogic;
      this.type = filter.type;
      return this;
    }
    this.search = '';
    this.supplierLeadTimeId = null;
    this.exceptProductOptionIds = null;
    this.includeRetired = false;
    this.alwaysIncludeImages = true;
    this.standaloneItem = null;
    this.partNumberLogic = null;
    this.type = null;
  }
}
